import { useLocation } from "react-router-dom";
import WarehouseOutWardActionV2 from "../../WarehouseOutWard/pages/WarehouseOutWardActionV2";
import SaleOutwardPage from "../SaleOutwardPage";
import { resolveOutwardRoute } from "./resolveOutwardRoute";

/**
 * Điểm vào chung của 3 URL create/edit/detail-warehouse-out-ward.
 * Giữ nguyên URL để các màn đang điều hướng vào, phân quyền menu và link mở tab mới vẫn chạy.
 * Phiếu bán (XUAT_BAN, XUAT_DOI_TRA) mở SaleOutwardPage; các loại khác vẫn mở trang cũ.
 * Muốn quay lại trang cũ cho phiếu bán: bỏ nhánh route.isSale.
 */
const OutwardActionDispatcher = () => {
  const location = useLocation();
  const route = resolveOutwardRoute({
    pathname: location.pathname,
    state: location.state,
    search: location.search,
  });

  if (route.isSale && route.sourceType) {
    // key: đổi phiếu hoặc chế độ thì dựng lại trang với state mới
    const key = [route.action, route.sourceType, route.id, route.transactionCode, route.sourceCode].join("|");
    return <SaleOutwardPage key={key} route={route} sourceType={route.sourceType as "XUAT_BAN" | "XUAT_DOI_TRA"} />;
  }
  return <WarehouseOutWardActionV2 />;
};

export default OutwardActionDispatcher;
